export default "__VITE_ASSET__C8eSFyFD__"